module.exports = __webpack_public_path__ + "img/add_remark_af.ca0a25af.svg";